export default {
    system: 'SongMingSlideManage',
    login: {
        username: 'username',
        password: 'password',
        login: 'login',
        loginOut: 'Log Out',
    },
    header: {
        system: 'system',
        category: 'Category Management',
        user: 'User Management',
        auth: 'authorization',
        function: 'Function management',
        case: 'case',
        album: 'album',
        share: 'share',
    },
    manage: {
        add: 'add',
        addUser: 'addUser',
        addRole: 'addRole',
        role: 'role',
        roleName: 'roleName',
        auth: 'permission',
        edit: 'edit',
        authEdit: 'Permission editing',
        delete: 'delete',
        confirm: 'confirm',
        operation: 'operation',
        share: 'share',
        browse: 'browse',
        view: 'view',
        save: 'save',
        back: 'back',
        search: 'search'
    },
    case: {
        case: 'case',
        caseNo: 'caseNo',
        title: 'title',
        name: 'name',
        age: 'age',
        sex: 'sex',
        male: 'male',
        female: 'female',
        null: 'null',
        specimen: 'specimen',
        clinicalData: 'clinicalData',
        generalObservations: 'generalObservations',
        diagnosis: 'diagnosis',
        list: 'Case List'
    },
    album: {
        title: 'title',
        describe: 'describe',
        list: 'Album List'
    },
    share: {
        slice: 'slice',
        createTime: 'createTime',
        expireTime: 'expireTime',
        permanent: 'permanent',
        timeLimit: 'Time Limit',
        isPassword: 'Do you need to share a code',
        yes: 'yes',
        no: 'no',
        password: 'Share Code',
        password_confrim: 'Share code verification',
        remark: 'remark',
        list: 'Share List'
    },
    body: {
        upload: 'upload',
        removeTo: 'remove to',
        download: 'download',
        delete: 'delete',
        share: 'share',
        share_click: 'Click to share',
        ctrl_c: 'Click to copy',
        close: 'close',
        copy_success: 'Copy Success',
        copy_fail: 'Copy Failed',
        error: 'Sliced resources have been lost or damaged'
    },
    upload: {
        select: 'Select File',
        selectUpload: 'Select file upload',
        start: 'Start uploading',
        complete: 'All files uploaded completed',
        error1: 'Upload failed',
        error2: 'Upload failed, upload capacity is full',
        begin: 'Start uploading, you can click on the icon in the upper right corner to check the upload status'
    },
    setting: {
        title: 'settings',
        Current_directory: 'Current home directory',
        set: 'Set as main catalogue',
        null: 'No subcategories'
    }
}
